import leven from 'leven';

/**
 * Calculate the similarity score between two strings.
 * 100 percent similarity is when the two strings are identical.
 * 0 percent similarity is when the two strings are completely different.
 */
export function calculateSimilarityScore(a: string, b: string) {
  const distance = leven(a, b);
  const maxLen = Math.max(a.length, b.length);
  if (maxLen === 0) return 100; // both empty
  const score = (1 - distance / maxLen) * 100;
  return Math.max(0, Math.min(100, score)); // clamp to 0–100
}
